<template>
  <slot />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";

const handleKeyDown = (e: KeyboardEvent) => {
  if (e.key === "Tab") {
    document.body.classList.add("tab-user");
  }
};

const handleMouseDown = () => {
  document.body.classList.remove("tab-user");
};

onMounted(() => {
  window.addEventListener("keydown", handleKeyDown);
  window.addEventListener("mousedown", handleMouseDown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeyDown);
  window.removeEventListener("mousedown", handleMouseDown);
});
</script>

<style scoped lang="scss"></style>
